<div class="message-toolbar">
  @for (action of actions(); track $index) {
    <button
      class="message-toolbar__button"
      [matTooltip]="action.tooltip"
      (click)="action.action()">
      <mat-icon>{{ action.icon }}</mat-icon>
    </button>
  }
</div>
